import "./index.scss";

import { Box } from "@mui/material";
import Table from "components/Table";
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import moment from "moment";
import {
  FC,
  forwardRef,
  memo,
  useCallback,
  useImperativeHandle,
  useLayoutEffect,
  useRef,
} from "react";
import { useReactToPrint } from "react-to-print";

export interface GeneratePdfRef {
  printContent: any;
  exportContent: any;
}

const GeneratePdfComp: FC<{
  title: string;
  subtitle?: string;
  type: string;
  tableData?: { rows: any; columns: any };
  ref?: any;
  tableProps?: any;
  className?: string;
  size?: "a4" | "a3" | "a2";
  orientation?: "portrait" | "landscape";
  children?: any;
}> = forwardRef((props, ref) => {
  const {
    title,
    subtitle,
    type,
    tableData = {
      columns: undefined,
      rows: undefined,
    },
    tableProps,
    className,
    size = "a3",
    orientation = "landscape",
    children,
  } = props;
  const { columns, rows } = tableData;

  const pdfPrintRef = useRef(null);

  useImperativeHandle(
    ref,
    (): GeneratePdfRef => ({
      exportContent: handleExportPDF,
      printContent: handlePrintPDF,
    })
  );

  const handlePrintPDF = useReactToPrint({
    content: () => pdfPrintRef.current,
    documentTitle: `${moment().format("DD/MM/YYYY")}-${type}-report`,
    removeAfterPrint: true,
  });

  const handleExportPDF = useCallback(() => {
    //console.log(pdfPrintRef.current);
    const printElement = document.querySelector(`#${type}-pdf-print`) as HTMLElement;

    var opt = {
      filename: `${moment().format("DD/MM/YYYY")}-${type}-report.pdf`,
      html2canvas: { scale: 1 },
      image: { quality: 0.98, type: "jpeg" },
      jsPDF: { format: size, orientation: `${orientation}` },
    };
    html2pdf().set(opt).from(printElement).save();
  }, []);

  // const handleExportPDF3 = useCallback(() => {
  //   const doc = new jsPDF({ orientation });
  //   autoTable(doc, {
  //     body: rows.map((row) => Object.values(row)),
  //     head: [Object.keys(rows[0])],
  //   });
  //   doc.save(`${moment().format("DD/MM/YYYY")}-${type}-report.pdf`);
  // }, [rows, orientation, type]);

  // const handleExportPDF2 = useReactToPrint({
  //   content: () => pdfPrintRef.current,
  //   documentTitle: `${moment().format("DD/MM/YYYY")}-${type}-report`,
  //   print: async (printIframe: HTMLIFrameElement) => {
  //     const document = printIframe.contentDocument;
  //     if (document) {
  //       const printElement = document.getElementsByTagName("html")[0];
  //       console.log(printElement);
  //       var opt = {
  //         filename: `${moment().format("DD/MM/YYYY")}-${type}-report.pdf`,
  //         html2canvas: { scale: 1 },
  //         image: { quality: 0.98, type: "jpeg" },
  //         jsPDF: { format: size, orientation: `${orientation}` },
  //       };
  //       html2pdf().set(opt).from(printElement).save();
  //     }
  //   },
  //   removeAfterPrint: true,
  // });

  /** Handle get height for table */
  const gridWrapperRef = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    const gridDiv = gridWrapperRef.current;
    if (gridDiv) {
      const gridEl: HTMLDivElement = gridDiv.querySelector("div")!;
      gridEl.style.height = "";
    }
  });

  //console.log(`rows has ${rows.length} rows`);
  return (
    <Box
      id={`${type}-pdf-print`}
      className={
        "generate-pdf-container" + ` ${size} ${orientation}` + `${className ? ` ${className}` : ""}`
      }
      width={"100%"}
      ref={pdfPrintRef}
    >
      <Box className="logo">
        <img alt="Activelinxx-logo" src={require("assets/images/logo/logo.png")} />
      </Box>
      <Box className="header">
        <h2>{title}</h2>
        <h3>{subtitle || moment().format("DD/MM/YYYY")}</h3>
      </Box>
      {children ? (
        children
      ) : (
        <Box ref={gridWrapperRef} className="table">
          <Table
            autoHeight
            rows={rows}
            columns={columns}
            rowCount={rows.length}
            pageSize={rows.length}
            {...tableProps}
            className="table-container__grid-table"
          />
        </Box>
      )}
    </Box>
  );
});

const GeneratePdf = memo(GeneratePdfComp);
export default GeneratePdf;
function autoTable(doc: jsPDF, arg1: { head: string[][]; body: any }) {
  throw new Error("Function not implemented.");
}
